// SQL LIKE-styl matching pro textové filtry (GH_ID, WSI): % = libovolný řetězec znaků, _ = libovolný jeden znak.
// Bez % a _ v patternu se chová jako dosud — prefix match (např. "O1" najde "O1234...").
export function likeMatch(value, pattern) {
  if (!pattern) return true
  if (value == null) return false
  if (!/[%_]/.test(pattern)) return value.startsWith(pattern)
  const escaped = pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const regex = new RegExp('^' + escaped.replace(/%/g, '.*').replace(/_/g, '.') + '$')
  return regex.test(value)
}

// Rozparsuje čárkou oddělený seznam GH_ID (např. z filters.plusGhId/minusGhId) na Set — ořeže mezery, vynechá prázdné.
export function parseGhIdList(value) {
  if (!value) return new Set()
  return new Set(value.split(',').map(v => v.trim()).filter(Boolean))
}

// Aplikuje force-include (+GH_ID) a force-exclude (-GH_ID) jako POSLEDNÍ krok nad výsledkem
// ostatních filtrů — vynucené stanice se vždy zobrazí/skryjí bez ohledu na ostatní filtry.
// Konflikt (stejné ID v obou seznamech): +GH_ID vyhrává.
export function applyPlusMinusGhId(filteredStations, allStations, plusGhId, minusGhId) {
  const plus = parseGhIdList(plusGhId)
  const minus = parseGhIdList(minusGhId)
  if (plus.size === 0 && minus.size === 0) return filteredStations

  let result = filteredStations
  if (minus.size > 0) result = result.filter(s => plus.has(s.gh_id) || !minus.has(s.gh_id))
  if (plus.size > 0) {
    const present = new Set(result.map(s => s.gh_id))
    const byId = new Map(allStations.map(s => [s.gh_id, s]))
    const extra = [...plus].filter(id => !present.has(id)).map(id => byId.get(id)).filter(Boolean)
    if (extra.length > 0) result = [...result, ...extra]
  }
  return result
}
